import { useSelector } from 'Modules/core/redux';


export type CertificatesPath = 'sign' | 'addToProfile';

const REDUCER_PATH = 'certificates';

export const useError = (path: CertificatesPath) =>
    useSelector(`${REDUCER_PATH}.${path}.error`, [path]);

export const useSelectedCertificate = (path: CertificatesPath) =>
    useSelector(`${REDUCER_PATH}.${path}.selected`, [path]);

export const useCertificates = (path: CertificatesPath): any[] =>
    useSelector(`${REDUCER_PATH}.${path}.available`, [path]);
